/** @format */

import { useLayoutEffect } from 'react';

const useScrollReset = (): null => {
  useLayoutEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  return null;
};

export default useScrollReset;
